import { __rest, __read, __assign } from 'tslib';
import React__default from 'react';
import { Caret } from '../../../assets/icons/Caret/Caret.esm.js';
import { ProfileIcon } from '../../../assets/icons/ProfileIcon.esm.js';
import LabcorpInvitaeLogoDark from '../../../assets/logos/LabcorpInvitaeLogoDark.esm.js';
import classNames from 'classnames';
import useOnClickOutside from 'use-onclickoutside';
import { IconMagnify, CircleVariant, ColorVariant } from '@invitae/iconograph-react';
import '@invitae/physician-cart';
import '@invitae/cms-blocks';
import '@invitae/nucleobase-engine-contentful';
import { CloseButton } from '../components/CloseButton/CloseButton.esm.js';
import menuItemStyles from '../components/MenuItem/MenuItem.module.esm.js';
import { MenuSection } from '../components/MenuSection/MenuSection.esm.js';
import 'lodash/omit';
import '../../../context/NavigationCtaContext.esm.js';
import 'lodash/lowerCase';
import '@invitae/ids-react';
import '../../CountrySwitcher/CountrySwitcher.esm.js';
import 'lodash/toLower';
import '../../../context/NavigationConfigContext.esm.js';
import 'lodash/debounce';
import '@invitae/nucleobase-analytics';
import '@invitae/react-hooks';
import styles from './SignedInNavigation.module.esm.js';

var SignedInNavigation = function (_a) {
    var _b, _c, _d;
    var avatarLabel = _a.avatarLabel, className = _a.className, dropDownMenu = _a.dropDownMenu, externalMenu = _a.externalMenu, externalMenuTitle = _a.externalMenuTitle, menuAriaLabel = _a.menuAriaLabel, menuLabel = _a.menuLabel, onSearchClick = _a.onSearchClick, searchAriaLabel = _a.searchAriaLabel, props = __rest(_a, ["avatarLabel", "className", "dropDownMenu", "externalMenu", "externalMenuTitle", "menuAriaLabel", "menuLabel", "onSearchClick", "searchAriaLabel"]);
    var _e = __read(React__default.useState(undefined), 2), isMenuOpen = _e[0], setMenuOpen = _e[1];
    var menuRef = React__default.useRef(null);
    var menuButtonRef = React__default.useRef(null);
    // on escape key close the menu
    React__default.useEffect(function () {
        var escHandler = function (ev) {
            if (ev.key === 'Escape')
                setMenuOpen(false);
        };
        document.addEventListener('keyup', escHandler);
        return function () { return document.removeEventListener('keyup', escHandler); };
    }, []);
    // close menu when it is open and there is a click outside the menu area
    useOnClickOutside(menuRef, function (e) {
        var _a;
        var eventTarget = e.target;
        if (menuButtonRef.current === eventTarget || ((_a = menuButtonRef.current) === null || _a === void 0 ? void 0 : _a.contains(eventTarget)))
            return;
        setMenuOpen(false);
    });
    // drag right to close on mobile
    var position = React__default.useRef({ initialX: 0, x: 0 });
    var onTouchStart = function (ev) {
        position.current.initialX = ev.targetTouches[0].pageX;
        position.current.x = ev.targetTouches[0].pageX;
    };
    // close menu when focus moves out of the menu
    var rootRef = React__default.useRef(null);
    React__default.useEffect(function () {
        if (!rootRef.current)
            return;
        var currentRootRef = rootRef.current;
        var onFocusOutHandler = function (ev) {
            var _a;
            if (ev.target === menuButtonRef.current)
                return;
            if (rootRef.current && !rootRef.current.contains(ev.relatedTarget)) {
                setMenuOpen(false);
                (_a = menuButtonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            }
        };
        currentRootRef.addEventListener('focusout', onFocusOutHandler);
        return function () { return currentRootRef.removeEventListener('focusout', onFocusOutHandler); };
    }, []);
    var setMenuBottomAndRightProps = function (button) {
        var _a, _b;
        var menuButtonBoundingClientRect = button.getBoundingClientRect();
        var myAccountButtonWithBorder = menuButtonBoundingClientRect.bottom - 2;
        (_a = menuRef.current) === null || _a === void 0 ? void 0 : _a.style.setProperty('--desktopInsetBlockStart', "".concat(myAccountButtonWithBorder, "px"));
        (_b = menuRef.current) === null || _b === void 0 ? void 0 : _b.style.setProperty('--desktopInsetInlineEnd', "calc(100vw - ".concat(menuButtonBoundingClientRect.right, "px)"));
    };
    var toggleMenu = function () {
        if (menuButtonRef.current) {
            setMenuBottomAndRightProps(menuButtonRef.current);
        }
        setMenuOpen(function (prevIsMenuOpen) {
            var _a;
            var nextValue = !prevIsMenuOpen;
            var isClosing = !nextValue;
            if (isClosing) {
                (_a = menuButtonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            }
            return nextValue;
        });
    };
    var onTouchMove = function (ev) {
        position.current.x = ev.targetTouches[0].pageX;
        var xDiff = position.current.initialX - position.current.x;
        if (xDiff > 0) {
            position.current.x = position.current.initialX;
            xDiff = 0;
        }
        if (menuRef.current) {
            // eslint-disable-next-line spellcheck/spell-checker
            menuRef.current.style.setProperty('transform', "translate(calc(0% - ".concat(xDiff, "px))"));
            menuRef.current.style.setProperty('transition-duration', '0ms');
        }
    };
    var onTouchEnd = function () {
        var SWIPE_LENGTH_NEEDED_TO_CLOSE_MENU = 40;
        var xDiff = Math.abs(position.current.initialX - position.current.x);
        if (xDiff > SWIPE_LENGTH_NEEDED_TO_CLOSE_MENU) {
            toggleMenu();
        }
        if (menuRef.current) {
            menuRef.current.style.removeProperty('transform');
            menuRef.current.style.removeProperty('transition-duration');
        }
        position.current.initialX = 0;
        position.current.x = 0;
    };
    return (React__default.createElement("header", __assign({ className: classNames(styles.root, className), ref: rootRef }, props),
        React__default.createElement("nav", { "aria-label": menuAriaLabel, className: classNames('nv-container', styles.container) },
            React__default.createElement(React__default.Fragment, null,
                React__default.createElement("a", { href: "/" },
                    React__default.createElement(LabcorpInvitaeLogoDark, { height: 30, width: 250 }))),
            React__default.createElement("div", { className: styles.menuBar },
                React__default.createElement("ul", { className: menuItemStyles['externalMenu--menubar'] }, externalMenu),
                onSearchClick && (React__default.createElement("button", { className: styles.searchButton, onClick: onSearchClick },
                    React__default.createElement(IconMagnify, { circle: CircleVariant.no, color: ColorVariant.default, size: "small" }),
                    React__default.createElement("span", { className: styles['visually-hidden'] }, searchAriaLabel))),
                React__default.createElement("button", { "aria-expanded": isMenuOpen, "aria-haspopup": true, className: styles.profileButton, onClick: toggleMenu, ref: menuButtonRef },
                    React__default.createElement("div", { className: styles.profileCard },
                        React__default.createElement("div", { className: styles.profileIcon },
                            React__default.createElement(ProfileIcon, { "aria-hidden": true })),
                        React__default.createElement("span", { className: styles.avatarLabel }, avatarLabel),
                        React__default.createElement("div", { className: styles.menuLabel },
                            React__default.createElement("span", { className: styles.menuLabelText }, menuLabel),
                            React__default.createElement(Caret, { "aria-hidden": true, direction: isMenuOpen ? 'down' : 'right' }))))),
            React__default.createElement("div", { className: classNames(styles.backdrop, (_b = {}, _b[styles['backdrop--show']] = isMenuOpen, _b)) },
                React__default.createElement("div", { "aria-label": menuAriaLabel, className: classNames(styles.nav, (_c = {},
                        _c[styles['nav--open']] = isMenuOpen,
                        _c[styles['nav--closed']] = isMenuOpen !== undefined && !isMenuOpen,
                        _c)), onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart },
                    React__default.createElement("div", { className: classNames(styles.menu, (_d = {},
                            _d[styles['menu--open']] = isMenuOpen,
                            _d)), ref: menuRef },
                        React__default.createElement("div", { className: styles.profileCard },
                            React__default.createElement("div", { className: styles.profileIcon },
                                React__default.createElement(ProfileIcon, { "aria-hidden": true })),
                            React__default.createElement("span", { className: styles.avatarLabel }, avatarLabel),
                            React__default.createElement("div", { className: styles.menuLabel },
                                React__default.createElement("span", { className: styles.menuLabelText }, menuLabel),
                                React__default.createElement(Caret, { "aria-hidden": true, direction: isMenuOpen ? 'down' : 'right' })),
                            React__default.createElement(CloseButton, { ariaLabel: "Close navigation menu", className: styles.closeButton, onClick: toggleMenu })),
                        React__default.createElement("ul", { className: styles.dropDownMenu },
                            React__default.createElement(MenuSection, { className: menuItemStyles['externalMenu--dropdown'], title: externalMenuTitle }, externalMenu),
                            isMenuOpen && dropDownMenu)))))));
};

export { SignedInNavigation };
//# sourceMappingURL=SignedInNavigation.esm.js.map
